import deburr from "lodash/deburr";

function canonize() {
  return function (string) {
    return deburr(string).toLowerCase();
  };
}

export default canonize;
